// 第四層頁型模板的統一出口，以及路由層要用的 pageType → 模板對照表。
//
// 路由層的用法：
//   const Template = TEMPLATE_BY_PAGE_TYPE[entry.pageType];
//   <Template route={entry} />
//
// 型別寫成 Record<PageType, …>（不是 Partial），所以 routes.generated.ts 之後多了新的
// pageType 而這裡漏掉，會直接編譯失敗，不會等到 runtime 才炸。

import type { ComponentType } from 'react';
import type { PageType } from '@/app/routes.generated';
import { ComplexFormPage } from './ComplexFormPage';
import { CrudListPage } from './CrudListPage';
import { DisplayPage } from './DisplayPage';
import { LoginPage } from './LoginPage';
import { RedirectPage } from './RedirectPage';
import { ReportPage } from './ReportPage';
import type { PageTemplateProps } from './types';
import { UnresolvedPage } from './UnresolvedPage';

export { ComplexFormPage } from './ComplexFormPage';
export { CrudListPage } from './CrudListPage';
export { DisplayPage } from './DisplayPage';
export { LoginPage } from './LoginPage';
export { RedirectPage } from './RedirectPage';
export { ReportPage } from './ReportPage';
export type { PageTemplateProps } from './types';
export { UnresolvedPage } from './UnresolvedPage';

export const TEMPLATE_BY_PAGE_TYPE: Record<PageType, ComponentType<PageTemplateProps>> = {
  'crud-list': CrudListPage,
  report: ReportPage,
  'complex-form': ComplexFormPage,
  display: DisplayPage,
  login: LoginPage,
  redirect: RedirectPage,
  unresolved: UnresolvedPage,
};
